export default __webpack_public_path__ + "static/media/image-chair-algo-d-2-a-w.fe3b39ec.webp";